// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__18yL8","newExpiryDate":"styles_newExpiryDate__3Qnt4","footer":"styles_footer__3WAoh"};